import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  descriptionHtml:
    "Play the volume V<sub>ab</sub> and the resonance frequency f<sub>b</sub> of the speaker's enclosure to see their effects on the frequency response curves. These parameters can be tuned as a function of the equivalent volume of the driver Vas and its resonance frequency f<sub>s</sub>.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0421/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
